export default __webpack_public_path__ + "static/media/play_arrow.9ace4497.svg";